export const ChannelsConfigForm = () => {
  return <form>TEST</form>;
};

export default ChannelsConfigForm;
